export default __webpack_public_path__ + "static/media/massage-back.21ea759e.jpg";